import React from "react";
import { useLocation } from "react-router-dom";
import MPMCModuleSubtopic from "../MPMCModuleSubtopic";

const MPMC_ModuleSummary = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <MPMCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Module Summary"
      videos={[]} // No specific video links provided
      takeaways={[
        { text: "Expect debugging-type questions, especially from this module and port programming (Module 4)." },
        { text: "If coding is unclear, memorize model codes (only 3-4 main codes) and understand where to change values." },
        { text: "Time delay using loops follows a standard structure—know when to use which type and how to calculate delay." },
        { text: "In stack operations, learn to move values between different register banks using PSW values." },
        { text: "Understand the theory and syntax for addressing modes." },
        { text: "Be familiar with moving values from ROM to RAM using MOVC, MOVX instructions." },
        { text: "Arithmetic operations may involve adding values from memory locations or solving given expressions." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // No example question videos provided
    />
  );
}

export default MPMC_ModuleSummary;
